import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslations from './locales/en.json';
import deTranslations from './locales/de.json';
import frTranslations from './locales/fr.json';
import nlTranslations from './locales/nl.json';
import idTranslations from './locales/id.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  },
  fr: {
    translation: frTranslations
  },
  nl: {
    translation: nlTranslations
  },
  id: {
    translation: idTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    }
  });

export default i18n; 